import {mixin} from "./helpers/helper";

require('./bootstrap');
import {store} from './storing/store';
import {i18n} from './translating/translate';
import {routes} from './routes';
import VueRouter from 'vue-router';
import Auth from './mixin/Auth';
import money from 'v-money';
import VueNumeric from 'vue-numeric';
import 'vue-select/dist/vue-select.css';

import VueCurrencyFilter from 'vue-currency-filter'
import VueCookie from 'vue-cookie';
import KProgress from 'k-progress';
import vSelect from 'vue-select';

//vue modal
import VModal from 'vue-js-modal';
// end vue modal


import Vue from 'vue';
window.Vue = Vue;
Vue.use(VueRouter);
Vue.use(VModal);

Vue.use(VueCookie);
Vue.use(money, {precision: 2});
Vue.use(VueNumeric);
Vue.use(VueCurrencyFilter,
    {
        symbol: '',
        thousandsSeparator: '.',
        fractionCount: 0,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    });

Vue.component('google-auhtorize-button', require('./components/calendar/authorization_button.vue'));
Vue.component('vue-layout', require('./pages/layout/main.vue').default);
Vue.component('k-progress', KProgress);
Vue.component('v-select', vSelect);

Vue.mixin(Auth);
window.token = localStorage.getItem('access_token');
const router = new VueRouter({
    mode: 'history',
    routes
});

if (window.location.pathname != '/login' && window.location.pathname != '/adm/stats') {
    router.beforeEach((to, from, next) => {
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const requiresCoach = to.matched.some(record => record.meta.requiresCoach);

        if (requiresAuth === true && window.token === null) {
            window.location.href = '/login';
        } else {
            if (requiresCoach === true) {

                if (localStorage.getItem('ur_type') == 98 || localStorage.getItem('ur_type') == 100) {
                    next();
                } else {
                   window.location.href = '/login';
                }
            } else {
                next();
            }
        }
    });
}
if (!window.localStorage.getItem('language') && window.localStorage.getItem('access_token')) {
    window.localStorage.removeItem('access_token');
    window.location.href="/it"
}
const app = new Vue({
        store,
        i18n: i18n,
        router,
        el: '#app',
        data: {},
        created: function () {

        },
        methods: {}
    }
);

// VENDOR
var rt_size;
var rt_force_size;
if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1279) {
    jQuery(function () {
        jQuery('#resize').click();
        localStorage.setItem('rsz', 'done');
        rt_force_size = 0;
    });
}

$(document).ready(function () {
    $(window).resize(function () {
        rt_size = $(this).width();
        if ($(this).width() < 1279) {
            jQuery(function () {
                if (localStorage.getItem('rsz') != 'done') {
                    jQuery('#resize').click();
                }
                localStorage.setItem('rsz', 'done');
                rt_force_size = 0;
            });
        }

        if ($(this).width() > 1279) {
            jQuery(function () {
                if (localStorage.getItem('rsz') === 'done') {
                    jQuery('#resize').click();
                }
                localStorage.setItem('rsz', '');
                rt_force_size = 0;
            });
        }
    });
});
//

Pace.on('hide', function () {
    document.getElementById('app').style.display = 'block';
});

 

function checkCoach() {
    alert('ss');
}

window.root = app;